import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../../prototypes/generic.view.ts';

import Handlebars from 'handlebars';
import HandlebarsHelpers from 'handlebarsHelpers';

import Template from 'text-loader!../templates/activateUser.template.hbs';

import i18n from "l10n";

export default GenericView.extend({
    el: "#main",
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
		var self = this;

        this.userHash = options ? options.userHash : "failed";

        if(this.userHash) {
            this.activateUser().then(() => this.render()).catch(() => this.render());
        }
        // else {
		// this.render();
        // }
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

        var params = {
            "status": this.activated
        };

		this.$el.html( this.template(params) );

		return this;
	},
	events:{

	},
	activateUser: function() {
	    var self = this;

	    return $.ajaxDefaultQ({
        	url: window.ip+'/rest/auth/users/activate/' + this.userHash,
        	type: 'PUT',
        }).done(function(response, status, xhr){
        	if(!response.error) {
        	    self.activated = "success";
        	}
        	else {
        	     self.activated = null;
        	}
        })
        .fail(function(response) {
            self.activated = "failed";
        })
	}
});
